import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { GoogleOAuthProvider, GoogleLogin, googleLogout } from '@react-oauth/google';
import { USER_LOGIN } from '../../store/actions';
import { Card, Alert, AlertTitle, Dialog, Button } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import StickyHeaErrorQueryTable from '../components/Table/StickyHeaErrorQueryTable';
import axios from "../../components/axios";
import { useLocation } from 'react-router-dom';

const TestErrorQuerySharePage = () => {
  const client_id = process.env.REACT_APP_CLIENT_ID;
  var user_login = useSelector(state => state.customization.login);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(true);
  const [showAlert, setshowAlert] = useState(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const threshold = 1000;
  const [openSummary, setOpenSummary] = useState(false);
  const [itemOption, setItemOption] = useState([]);
  const [homeAppRecord, setHomeAppRecord] = useState([]);
  const showShare = false;
  const showSummary = true;

const styleButton = {
        width: "120px",
        fontSize: "16px",
        fontFamily: '"Roboto", "sans-serif"',
    };

  const columns = [
    { id: 'serial_number', label: 'Serial Number', align: 'left' },
    { id: 'platform', align: 'center', label: 'Platform'},
    { id: 'suite_name', align: 'center', label: 'Suite Name'},
    { id: 'home_app', align: 'center', label: 'Home App'},
    { id: 'system_image', align: 'center', label: 'System Image'},
    { id: 'system_image_type', align: 'center', label: 'Image Type'},
    { id: 'start_time', align: 'center', label: 'Start Time'},
    { id: 'end_time', align: 'center', label: 'End Time'},
    { id: 'action', label: 'Download', align: 'center', action: true},
    { id: 'view', label: 'Show', align: 'center', view: true },
  ];

  const summaryColumns = [
    { id: 'home_app_version', label: 'Home App', align: 'left' },
    { id: 'ANR_pass_count', align: 'center', label: 'Pass'},
    { id: 'ANR_fail_count', align: 'center', label: 'Fail'},
    { id: 'ANR_skip_count', align: 'center', label: 'Skip'},
    { id: 'Kernel_pass_count', align: 'center', label: 'Pass'},
    { id: 'Kernel_fail_count', label: 'Fail', align: 'center'},
    { id: 'Kernel_skip_count', label: 'Skip', align: 'center'},
  ];

  const handleSummary = () => {
    setOpenSummary(true)
  };

  const useQueryParams = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQueryParams();

  const handleQueryData = useCallback(() => {
        setRows([]);
        setItemOption([]);
        setHomeAppRecord([]);
        var input_data = JSON.stringify({ query: query.get("query")})
        axios.post("/peloton/v1/automation/share-error-report",input_data,{withCredentials: true})
        .then(response => {
          if (response.data.message === "success") {
            dispatch({ type: USER_LOGIN, login: true });
            if (response.data.data !== null && response.data.data.length > 0){
              if (response.data.data.length >threshold){
                  setshowAlert(true);
                  setNoDataMessage('More than 1000 rows, please click "Export Data" to download file')
              }else{
                setRows(response.data.data);
                setshowAlert(false);
              }
              setItemOption(response.data.item_option);
              setHomeAppRecord(response.data.home_app_record);
              setshowTable(true);
            }else{
              setNoDataMessage('No data in this condition.')
              setshowAlert(true);
            }
          }else{
            alert(response.data.message);
          }
        }).catch(error => {
          if (error.message === 'timeout of 3000ms exceeded'){
            setshowAlert(true);
            setNoDataMessage('Too many rows, please click "Export Data" to download file')
            setshowTable(true);
          }else{
            if (!error.response){
              alert(error)
            }else{
              if (error.response.status === 401){
                dispatch({ type: USER_LOGIN, login: false });
              }else{
                alert(error.response.data.message);
              }
            }
          }
        })
    }, [dispatch, query]);

    const handleLogout = useCallback(() => {
        googleLogout();
        axios.post("/peloton/v1/users/logout", null, { withCredentials: true});
        alert("Logout success!");
        localStorage.removeItem("gapi.tokenId");
        localStorage.removeItem("qbarn.user");
        dispatch({ type: USER_LOGIN, login: false });
    }, [dispatch]);

  useEffect(() => {
    const checkUserToken = async () => {
            try {
                const response = await axios.post("/peloton/v1/users/auth-token", null, { withCredentials: true});
                if (response.data.message === "success"){
                    dispatch({ type: USER_LOGIN, login: true });
                    handleQueryData();
                }
            } catch (error) {
                handleLogout();
                if (error.response.status !== null){
                    console.log('error.response.status: ', error.response.status);
                    console.log('error.response.message: ', error.response.data.message);
                }else{
                    console.log(error);
                }
            }
        };
        if (localStorage.getItem( "qbarn.user" ) !== null) {
            checkUserToken();
        }else{
            dispatch({ type: USER_LOGIN, login: false });
        }
  }, [dispatch, handleQueryData, handleLogout]);

  const handleClose = () => {
    setOpenSummary(false);
  };

  const handleDownload = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid })
      axios.post("/peloton/v1/automation/test-report-file", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(response.data.url, "_blank");
        }else{
            alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            dispatch({ type: USER_LOGIN, login: false });
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  const handleRedirect = (uuid) => {
      var input_data = JSON.stringify({ item_uuid: uuid });
      axios.post("/peloton/v1/automation/test-report-pages", input_data, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          window.open(process.env.REACT_APP_API_URL+response.data.url, "_blank");
        }else{
          alert(response.data.message);
        }
      })
      .catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            dispatch({ type: USER_LOGIN, login: false });
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
  };

  function getPermission() {
        let idToken = localStorage.getItem( "gapi.tokenId" )
        axios.post("/peloton/v1/users/role-permission",null,{
            headers: {
              'Authorization': 'Bearer '+idToken
            },
            withCredentials: true
        })
        .then(response => {
            if (response.data.message === "success") {
                if (localStorage.getItem( "qbarn.user" ) === null && response.data.user_info !== undefined) {
                    localStorage.setItem("qbarn.user", JSON.stringify(response.data.user_info))
                    handleQueryData();
                }
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
              if (err.response.status === 401){
                  dispatch({ type: USER_LOGIN, login: false });
              }else{
                  console.log('error.response.status: ', err.response.status)
                  console.log('error.response.status: ', err.response.data.message)
                  alert(err.response.data.message)
              }
            }
        })
    };

  const responseGoogle = (response) => {
    dispatch({ type: USER_LOGIN, login: true });
    localStorage.setItem("gapi.tokenId",response.credential);
    getPermission();
  };

  return (
    <MainCard>
      <Dialog open={openSummary} onClose={handleClose} maxWidth='md' scroll='body' fullWidth>
        <MainCard>
        <StickyHeaErrorQueryTable rows={homeAppRecord} columns={summaryColumns} item_option={itemOption} />
        </MainCard>
      </Dialog>
      {!user_login && (
                <GoogleOAuthProvider clientId={client_id}>
                    <GoogleLogin
                        onSuccess={responseGoogle}
                        onError={responseGoogle}
                        text='Login'
                        useOneTap
                  /></GoogleOAuthProvider>)}
      {user_login && (<Button style={styleButton} onClick={handleLogout}>Logout</Button>)}
      { user_login && showTable && (<StickyHeadTwoButtonTable rows={rows} columns={columns} handleDownload={handleDownload} handleRedirect={handleRedirect} showSummary={showSummary} handleSummary={handleSummary} showShare={showShare}/>)}
      { user_login && showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}
    </MainCard>)
};

export default TestErrorQuerySharePage;
